import React from 'react';
import { motion } from 'framer-motion';
import { Virtual, Navigation, Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import { isDesktop } from 'js/utils/deviceDetection';

import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

import IconChevronRight from 'js/components/icon/Icon.chevron-right';
import IconChevronLeft from 'js/components/icon/Icon.chevron-left';

const slideVariants = {
  hidden: {
    x: 100,
    opacity: 0,
  },
  visible: (index) => ({
    x: 0,
    opacity: 1,
    transition: {
      type: 'spring',
      stiffness: 120,
      damping: 14,
      mass: 0.8,
      delay: index * 0.25,
    },
  }),
};

const SwiperVirtual = ({ width = 160, slides = [] }) => {
  const [hasAnimated, setHasAnimated] = React.useState(false);

  return (
    <div
      style={{
        width: 'calc(100% + 40px)',
        overflowX: 'hidden',
        left: '-20px',
        position: 'relative',
      }}
    >
      <Swiper
        className="swiper--carousel"
        modules={[Virtual, Navigation, Pagination]}
        spaceBetween={15}
        slidesOffsetBefore={20}
        slidesOffsetAfter={20}
        slidesPerView="auto"
        navigation={{
          prevEl: '.swiper-button-prev__virtual',
          nextEl: '.swiper-button-next__virtual',
          addIcons: false,
        }}
        virtual={{
          slidesPerViewAutoSlideSize: width,
        }}
      >
        {slides.map((slide, index) => (
          <SwiperSlide key={index} virtualIndex={index}>
            {index < 4 ? (
              <motion.div
                variants={slideVariants}
                initial={!hasAnimated ? 'hidden' : 'visible'}
                animate="visible"
                custom={index}
                onAnimationComplete={() => {
                  if (!hasAnimated && (index === 3 || index === slides.length - 1)) {
                    setHasAnimated(true);
                  }
                }}
              >
                {slide}
              </motion.div>
            ) : (
              slide
            )}
          </SwiperSlide>
        ))}

        {isDesktop() === 'desktop' && (
          <>
            <div className="swiper-button-prev swiper-button-prev__virtual">
              <IconChevronLeft />
            </div>
            <div className="swiper-button-next swiper-button-next__virtual">
              <IconChevronRight />
            </div>
          </>
        )}
      </Swiper>
    </div>
  );
};

export default SwiperVirtual;
